import axios from 'axios';

export function getCustomerHarps(customerId) {
  return axios.get(`/api/customers/${customerId}/harps`);
}

export function addNewHarp(newHarp, customerId) {
  const harp = [newHarp.id];
  return axios.post(`/api/customers/${customerId}/harps`, { harps: harp });
}

export function deleteHarp(harpId, customerId) {
  return axios.delete(`/api/customers/${customerId}/harps/${harpId}`);
}

export function getHarps() {
  return axios.get('/api/harps');
}
